import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import grey from '@mui/material/colors/grey'
import DraggableConceptsList from '../concepts/DraggableConceptsList'

export default function IncludedConceptsDialog({
  show,
  setShow,
}: {
  show: boolean
  setShow: (t: boolean) => void
}) {
  return (
    <Dialog open={show} onClose={() => setShow(false)} fullWidth>
      <DialogTitle id='scroll-dialog-title'>Current Search Concepts</DialogTitle>
      <Divider sx={{bgcolor: grey[50], height: '5px'}} />
      <DialogContent>
        <Box>
          <DraggableConceptsList stackVertical={true} chipSize={'lg'} ignoredOnly={false} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setShow(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
